import { useRouteError } from 'react-router-dom';

const ErrorBoundary = () => {
  const error = useRouteError() as Error;

  return (
    <div className='flex flex-col items-center justify-center min-h-screen p-4 bg-red-50'>
      <div className='p-8 bg-white rounded-lg shadow-lg max-w-2xl w-full'>
        <h1 className='text-2xl font-bold text-red-600 mb-4'>Oops! Something went wrong</h1>
        <p className='text-gray-700 mb-4'>We encountered an error while trying to process your request.</p>
        <div className='bg-gray-100 p-4 rounded mb-4'>
          <p className='font-mono text-sm text-red-500'>{error.message || 'Unknown error'}</p>
        </div>
        <button
          onClick={() => (window.location.href = '/')}
          className='bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded'
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default ErrorBoundary;
